// src/holladai/hooks/useInventoryStats.js
import { useEffect, useState } from "react";
import { fetchInventoryStats } from "../services/inventoryStatsService";

export function useInventoryStats(hotelIds) {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;

    const numericIds = (hotelIds || [])
      .map((id) => Number(id))
      .filter((id) => !isNaN(id));

    if (numericIds.length === 0) {
      setData({});
      setError(null);
      setLoading(false);
      return;
    }

    async function load() {
      try {
        setLoading(true);
        setError(null);

        const result = await fetchInventoryStats(numericIds);
        if (!mounted) return;

        // Normalize keys to numbers
        const normalized = {};
        for (const [key, value] of Object.entries(result)) {
          normalized[Number(key)] = value;
        }

        setData(normalized);
      } catch (err) {
        if (mounted) setError(err.message || "Failed to fetch inventory stats");
      } finally {
        if (mounted) setLoading(false);
      }
    }

    load();
    return () => (mounted = false);
  }, [hotelIds]);

  return { data, loading, error };
}
